var ContextVariableFilter = /** @class */ (function () {
    function ContextVariableFilter() {
    }
    ContextVariableFilter.get = function (contextVariables, filters) {
        var filteredContextVariable = [];
        if (filters && filters.contextVariableUid) {
            for (var _i = 0, contextVariables_1 = contextVariables; _i < contextVariables_1.length; _i++) {
                var contextVariable = contextVariables_1[_i];
                for (var _a = 0, _b = filters.contextVariableUid; _a < _b.length; _a++) {
                    var cvUid = _b[_a];
                    if (contextVariable.uid === cvUid) {
                        filteredContextVariable.push(contextVariable);
                    }
                }
            }
            return filteredContextVariable;
        }
        else {
            return contextVariables;
        }
    };
    ContextVariableFilter.getOne = function (contextVariables, contextVariableUid) {
        var filteredContextVariable = ContextVariableFilter.get(contextVariables, { contextVariableUid: [contextVariableUid] });
        if (filteredContextVariable.length === 0) {
            return null;
        }
        if (filteredContextVariable.length > 1) {
            throw "getOne() return mor than 1 ContextVariable";
        }
        if (filteredContextVariable.length === 1) {
            return filteredContextVariable[0];
        }
        return null;
    };
    ContextVariableFilter.sortByPriority = function (contextVariables, asc) {
        if (asc === void 0) { asc = true; }
        return contextVariables.sort(function (a, b) {
            return asc ? a.priority - b.priority : b.priority - a.priority;
        });
    };
    return ContextVariableFilter;
}());
export default ContextVariableFilter;
//# sourceMappingURL=ContextVariableFilter.js.map